<template>
  <div id="footer_list" class="footer-list">
    <a
      index="1"
      class="activeClass"
      href="https://h5.11visa.com/#/activity/cfdeb7?distributor_id=10008"
    >
      <img class="tab_icon" src="../../../../static/img/visa.png" />
    </a>
    <a index="2" href="https://itravel.hwht.com/sale?id=tjt202001">
      <img class="tab_icon" src="../../../../static/img/fly.png" />
    </a>
    <a
      index="3"
      class="change-html"
      href="https://www.gowithtommy.com/tjt.html#/activity"
    >
      <img class="tab_icon" src="../../../../static/img/attractions.png" />
    </a>
    <a
      index="4"
      href="https://www.booking.com/china_coupon_campaign.zh-cn.html?ccacn=huawei_skytone_and_live_1&aid=1738670"
    >
      <img class="tab_icon" src="../../../../static/img/hotel.png" />
    </a>
  </div>
</template>

<script>
// import $ from 'jquery';

export default {
  name: 'sky-tone-nav',
  mounted() {
    // $('#footer_list').on('click', 'a', function click(event) {
    //   $(this).addClass('activeClass').siblings().removeClass('activeClass');
    //   if (event.target.tagName === 'IMG') {
    //     const nodes = $('#footer_list a img');
    //     for (let i = 0; i < nodes.length; i++) {
    //       nodes[i].src = nodes[i].src.replace(/.png|_selected.png/, '.png');
    //     }
    //     event.target.src = event.target.src.replace(/.png|_selected.png/, '_selected.png');
    //   }
    //   // 记录第四个按钮应该连接哪一个链接
    //   const theIndex = $(this).attr('index');
    //   if (theIndex === '1' || theIndex === '3') {
    //     $('.change-html').attr('href', 'https://www.sanmaoyou.com/Public/projects/tjtWeb/#/');
    //   } else if (theIndex === '2') {
    //     $('.change-html').attr('href', 'https://www.gowithtommy.com/tjt.html#/activity');
    //   }
    //   const $url = $(this).attr('href');
    //   const $iframe = $('.container');
    //   $iframe.attr('src', $url);
    // });
  },
};
</script>

<style lang="less" scoped>
.footer-list {
  display: flex;
  margin-top: -1px;
  border-bottom: none;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  background-color: #d0301a;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0.64rem;
  padding-bottom: env(safe-area-inset-bottom);
}
.footer-list a {
  padding: 2px 4px;
  flex-grow: 1;
  text-align: center;
}
.tab_icon {
  display: block;
  width: 55px;
  max-height: 55px;
  margin: 0 auto;
  overflow: hidden;
}
img {
  width: 100%;
  height: 100%;
  display: block;
  border-style: none;
}
</style>
